export const queryKeys = {
  products: {
    all: () => ['products'] as const,
    filtered: (filters?: Record<string, unknown>) => ['products', filters] as const,
    detail: (id: string) => ['products', id] as const,
    byIds: (ids: string[]) => ['products', 'byIds', ids] as const,
    externalMappings: (id: string) => ['products', id, 'externalMappings'] as const,
  },
  categories: {
    all: () => ['categories'] as const,
    tree: () => ['categories', 'tree'] as const,
    detail: (id: string) => ['categories', id] as const,
  },
  brands: {
    all: () => ['brands'] as const,
    detail: (id: string) => ['brands', id] as const,
    byIds: (ids: string[]) => ['brands', 'byIds', ids] as const,
  },
  tags: {
    all: () => ['tags'] as const,
    detail: (id: string) => ['tags', id] as const,
  },
  orders: {
    all: () => ['orders'] as const,
    filtered: (filters?: Record<string, unknown>) => ['orders', filters] as const,
    detail: (id: string) => ['orders', id] as const,
  },
  account: {
    current: () => ['account', 'current'] as const,
    byHostname: (hostname: string) => ['account', 'hostname', hostname] as const,
    detail: (id: string) => ['account', id] as const,
  },
  tickets: {
    all: () => ['tickets'] as const,
    filtered: (filters?: Record<string, unknown>) => ['tickets', filters] as const,
    detail: (id: string) => ['tickets', id] as const,
  },
  socialUsers: {
    all: () => ['socialUsers'] as const,
    detail: (id: string) => ['socialUsers', id] as const,
  },
  posts: {
    all: () => ['posts'] as const,
    detail: (id: string) => ['posts', id] as const,
    byGroup: (groupId: string) => ['posts', 'group', groupId] as const,
  },
  channels: {
    all: () => ['channels'] as const,
    detail: (id: string) => ['channels', id] as const,
  },
  themes: {
    all: () => ['themes'] as const,
    active: () => ['themes', 'active'] as const,
    detail: (id: string) => ['themes', id] as const,
    presets: () => ['themes', 'presets'] as const,
  },
  templates: {
    all: () => ['templates'] as const,
    active: () => ['templates', 'active'] as const,
    detail: (id: string) => ['templates', id] as const,
  },
  users: {
    all: () => ['users'] as const,
    filtered: (filters?: Record<string, unknown>) => ['users', filters] as const,
    detail: (id: string) => ['users', id] as const,
    staff: () => ['users', 'staff'] as const,
    search: (query: string) => ['users', 'search', query] as const,
  },
  wishlist: {
    current: () => ['wishlist'] as const,
  },
  coupons: {
    all: () => ['coupons'] as const,
    detail: (id: string) => ['coupons', id] as const,
  },
  emailTemplates: {
    all: () => ['emailTemplates'] as const,
    detail: (id: string) => ['emailTemplates', id] as const,
  },
  workflows: {
    all: () => ['workflows'] as const,
    detail: (id: string) => ['workflows', id] as const,
  },
  inboxFolders: {
    all: () => ['inboxFolders'] as const,
  },
  postGroups: {
    all: () => ['postGroups'] as const,
    detail: (id: string) => ['postGroups', id] as const,
  },
  productGroups: {
    all: () => ['productGroups'] as const,
    detail: (id: string) => ['productGroups', id] as const,
  },
  addresses: {
    all: () => ['addresses'] as const,
    byUser: (userId: string) => ['addresses', 'user', userId] as const,
    my: () => ['addresses', 'my'] as const,
    detail: (id: string) => ['addresses', id] as const,
    myDefault: () => ['addresses', 'myDefault'] as const,
  },
  ticketReminders: {
    all: () => ['ticketReminders'] as const,
    count: () => ['ticketReminders', 'count'] as const,
    forTicket: (ticketId: string) => ['ticketReminders', 'ticket', ticketId] as const,
  },
  integrations: {
    status: () => ['integrations', 'status'] as const,
    wooStatus: () => ['integrations', 'wooStatus'] as const,
  },
  domainPresets: {
    all: () => ['domainPresets'] as const,
    detail: (id: string) => ['domainPresets', id] as const,
    preview: (id: string) => ['domainPresets', 'preview', id] as const,
  },
  features: {
    all: () => ['features'] as const,
    forAccount: (accountId: string) => ['features', accountId] as const,
  },
  accountSettings: {
    all: () => ['accountSettings'] as const,
    detail: (accountId: string) => ['accountSettings', accountId] as const,
  },
  userPreferences: {
    current: () => ['user-preferences'] as const,
  },
} as const;
